window.addEventListener("videowiseProductAddToCart", (event) => {
  // Close the video player.
  setTimeout(() => {
    window.dispatchEvent(new CustomEvent('videowiseTriggerPlayerClose'));
  }, 600);


  const variantId = event.detail.variantId || event.detail.id || (event.detail.product && event.detail.product.id);

  if (!variantId) {
    console.error("Videowise: Product ID not found.");
    return;
  }


  // We identify the theme's cart component (the one that has the addItemToCart method)
  const cartElement = document.querySelector('cart-drawer, cart-items, .shopify-section [section-id]');


  // We force the cart update, we put 0 in quantities because the videowise application sends the selected data to the player
  if (cartElement && typeof cartElement.addItemToCart === 'function') {
    cartElement.addItemToCart([{ id: variantId, quantity: 0 }]);

  }
  setTimeout(() => {
    const cartToggle = document.querySelector('dialog-toggle[modal-id="cart-drawer-dialog"]');
    if (cartToggle) {
      // We are trying to find the link inside the component
      const innerLink = cartToggle.querySelector('a#cart-icon-bubble');
      if (innerLink) {
        innerLink.click();
      } else {
        // If it's blocked by Shadow DOM, we force click on the parent element again
        cartToggle.click();
      }
    }
  }, 1600);
});
(function () {
  // Guard against the script being included more than once on the page.
  if (window.__vwUrlWatcherInit) return;
  window.__vwUrlWatcherInit = true;
  // Seed with the current path so the INITIAL page load is not treated as a URL
  // change (Videowise already initializes the widget natively on load). We only
  // re-init when the URL actually changes (e.g. variant switch).
  let lastProcessedUrl = window.location.pathname;
  function fetchAndUpdateProduct(handle) {
    const jsonUrl = `/products/${handle}.json`;
    fetch(jsonUrl)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(data => {
        if (!data.product || !data.product.id) return;
        const newProductId = data.product.id;
        if (window.__st) {
          window.__st.rid = newProductId;
          window.__st.pageurl = window.location.href;
        }
        if (typeof videowiseBulkTrigger === 'function') {
          const shopifyBlocks = document.querySelectorAll('[class*="videowise_video_commerce"], [id*="reeview-app-widget"]');
          shopifyBlocks.forEach(block => {
            const clone = block.cloneNode(false);
            if (clone.hasAttribute('data-product-id')) {
              clone.setAttribute('data-product-id', newProductId);
            }
            clone.innerHTML = '';
            block.parentNode.replaceChild(clone, block);
          });
          setTimeout(() => {
            window.videowiseIdsLoaded = [];
            if (typeof initVideowise === 'function') {
              try { initVideowise(); console.log('duplicate....') } catch (e) { }
            }
            window.videowiseBulkTrigger();
          }, 400);
        }
      })
      .catch(err => console.error(':x: Update error:', err));
  }
  const pushState = history.pushState;
  history.pushState = function () {
    pushState.apply(history, arguments);
    handleUrlChange();
  };
  const replaceState = history.replaceState;
  history.replaceState = function () {
    replaceState.apply(history, arguments);
    handleUrlChange();
  };
  window.addEventListener("popstate", handleUrlChange);
  function handleUrlChange() {
    const currentUrl = window.location.pathname;
    if (currentUrl === lastProcessedUrl) return;
    lastProcessedUrl = currentUrl;
    const handle = currentUrl.split("/").pop();
    if (handle && currentUrl.includes('/products/')) {
      fetchAndUpdateProduct(handle);
    }
  }
})();

(function hideVideowiseThumbnailsOnPagesOnly() {
  const currentPath = window.location.pathname;

  // Blochează execuția pe paginile de produs sau pe orice pagină care NU este de tip /pages/
  if (currentPath.includes('/products/') || !currentPath.includes('/pages/')) {
    return;
  }

  function cleanGallery() {
    const videowiseImages = document.querySelectorAll(
      'product-gallery-thumbnails img[alt*="videowise-widget-"], ' +
      'product-gallery-thumbnails img[src*="reeview-app-widget"], ' +
      'app-provider img[alt*="videowise-widget-"], ' +
      'app-provider img[src*="reeview-app-widget"], ' +
      'img[alt*="videowise-widget-"], ' +
      'img[src*="reeview-app-widget"]'
    );

    videowiseImages.forEach((img) => {
      // Căutăm containerul slide-ului
      const slide = img.closest('[data-carousel-slide]') || img.closest('.thumb');

      if (slide) {
        slide.style.setProperty('display', 'none', 'important');
        slide.style.setProperty('visibility', 'hidden', 'important');
      }
    });
  }

  // Execuție imediată
  cleanGallery();

  // Observator pentru conținut dinamic încărcat pe paginile /pages/
  const observer = new MutationObserver(cleanGallery);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();